import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "notice-trigger"
};
const _hoisted_2 = {
  class: "notice-container"
};
const _hoisted_3 = {
  class: "notice-header"
};
const _hoisted_4 = {
  class: "notice-list"
};
const _hoisted_5 = {
  key: 0,
  class: "empty-state"
};
const _hoisted_6 = {
  key: 1,
  class: "notice-items"
};
const _hoisted_7 = {
  class: "notice-avatar"
};
const _hoisted_8 = {
  key: 0,
  class: "notice-status"
};
const _hoisted_9 = {
  class: "notice-content"
};
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = {
  class: "notice-time"
};
const _hoisted_12 = {
  class: "notice-list"
};
const _hoisted_13 = {
  key: 0,
  class: "empty-state"
};
const _hoisted_14 = {
  key: 1,
  class: "notice-items"
};
const _hoisted_15 = {
  class: "notice-avatar"
};
const _hoisted_16 = {
  key: 0,
  class: "notice-status"
};
const _hoisted_17 = {
  class: "notice-content"
};
const _hoisted_18 = {
  class: "notice-text"
};
const _hoisted_19 = {
  class: "notice-time"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vab_icon = _resolveComponent("vab-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_avatar = _resolveComponent("el-avatar");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_badge = _resolveComponent("el-badge");
  return $setup.theme.showNotice ? (_openBlock(), _createBlock(_component_el_badge, {
    key: 0,
    class: "notice-badge",
    type: "danger",
    value: $setup.badge
  }, {
    default: _withCtx(() => [_createVNode(_component_el_popover, {
      placement: "bottom-end",
      "popper-class": "notice-popover",
      "show-arrow": false,
      width: 380
    }, {
      reference: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_vab_icon, {
        icon: "notification-line"
      })])]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h3", null, _toDisplayString($setup.translate('消息中心')), 1 /* TEXT */), _createVNode(_component_el_button, {
        class: "clear-btn",
        size: "small",
        text: "",
        type: "primary",
        onClick: $setup.handleClearNotice
      }, {
        default: _withCtx(() => [_createVNode(_component_vab_icon, {
          icon: "delete-bin-line"
        }), _createTextVNode(" " + _toDisplayString($setup.translate('清空')), 1 /* TEXT */)]),
        _: 1 /* STABLE */
      })]), _createVNode(_component_el_tabs, {
        modelValue: $setup.activeName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.activeName = $event),
        class: "notice-tabs",
        onTabClick: $setup.handleClick
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: $setup.translate('通知'),
          name: "notice"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_scrollbar, {
            height: "320px"
          }, {
            default: _withCtx(() => [$setup.notices.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_vab_icon, {
              class: "empty-icon",
              icon: "notification-off-line"
            }), _createElementVNode("p", null, _toDisplayString($setup.translate('暂无通知')), 1 /* TEXT */)])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.notices, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                class: "notice-item"
              }, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_avatar, {
                size: 40,
                src: item.image
              }, null, 8 /* PROPS */, ["src"]), !item.read ? (_openBlock(), _createElementBlock("div", _hoisted_8)) : _createCommentVNode("v-if", true)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
                class: "notice-text",
                innerHTML: item.notice
              }, null, 8 /* PROPS */, _hoisted_10), _createElementVNode("div", _hoisted_11, _toDisplayString($setup.formatTime(item.time || new Date())), 1 /* TEXT */)])]);
            }), 128 /* KEYED_FRAGMENT */))]))]),
            _: 1 /* STABLE */
          })])]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]), _createVNode(_component_el_tab_pane, {
          label: $setup.translate('邮件'),
          name: "email"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_scrollbar, {
            height: "320px"
          }, {
            default: _withCtx(() => [$setup.notices.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_vab_icon, {
              class: "empty-icon",
              icon: "mail-line"
            }), _createElementVNode("p", null, _toDisplayString($setup.translate('暂无邮件')), 1 /* TEXT */)])) : (_openBlock(), _createElementBlock("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.notices, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                class: "notice-item"
              }, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_avatar, {
                size: 40,
                src: item.image
              }, null, 8 /* PROPS */, ["src"]), !item.read ? (_openBlock(), _createElementBlock("div", _hoisted_16)) : _createCommentVNode("v-if", true)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString(item.email), 1 /* TEXT */), _createElementVNode("div", _hoisted_19, _toDisplayString($setup.formatTime(item.time || new Date())), 1 /* TEXT */)])]);
            }), 128 /* KEYED_FRAGMENT */))]))]),
            _: 1 /* STABLE */
          })])]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"])]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue"])])]),
      _: 1 /* STABLE */
    })]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["value"])) : _createCommentVNode("v-if", true);
}